export enum Roles {
    SystemAdministrator = '089e75b9-b853-494d-bd95-930912cd352e',
    AssociationResponsiblePerson = '4e3a2f49-17b2-4aa0-a93b-6f807c83fd23',
    MunicipalityAdministrator = '20e837b6-77d8-4756-9ce1-a9d92dd16084'  

}

export interface Role {
    id: string;
    name: string;
  }